import type { GraphQLResponse } from 'graphql-request';

import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ErrorTypeResponse } from '@/types/apps/error-type.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ErrorTypeGraphQLServiceInterface {}

type ErrorTypeGraphQLListResponse = GraphQLResponse<ErrorTypeResponse>;

export class ErrorTypeGraphQLService
    extends BaseService
    implements ErrorTypeGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'errorType';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
        };
    }

    public async index(query: string): Promise<ErrorTypeGraphQLListResponse> {
        return this.fetchGqlList<ErrorTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('errorType', {
            userId: this.getQueryById(),
        });
    }
}
